import { useState, type ImgHTMLAttributes } from 'react';
import { classNames } from '../lib/classNames';
import { fallbackImageUrl } from '../lib/assets';

export const AsyncImage = ({
  alt = '',
  className,
  src,
  ...props
}: ImgHTMLAttributes<HTMLImageElement>) => {
  const [loadedSrc, setLoadedSrc] = useState<string | undefined>();
  const [failedSrc, setFailedSrc] = useState<string | undefined>();
  const source = typeof src === 'string' ? src : undefined;
  const hasError = Boolean(source && failedSrc === source);
  const isLoading = Boolean(source && loadedSrc !== source && !hasError);

  return (
    <span className={classNames('image-shell', className)}>
      {isLoading && <span className="image-placeholder" aria-hidden="true" />}
      <img
        {...props}
        alt={hasError ? 'Failed to load' : alt}
        className={classNames('h-full w-full', isLoading && 'hidden')}
        src={hasError ? fallbackImageUrl : source}
        onError={() => {
          if (source) setFailedSrc(source);
        }}
        onLoad={() => {
          if (source) setLoadedSrc(source);
        }}
      />
    </span>
  );
};
